// App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/NavBar';
import LandingPage from './pages/LandingPage';
import Features from './pages/Features';
import Solution from './pages/Solution';
import About from './pages/About';
import Contact from './pages/Contact';
import Demo from './pages/Demo';

const App = () => {
  return (
    <Router>
      <div className="min-h-screen bg-white">
        <Navbar />
        <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/Features" element={<Features />} />
        <Route path="/Solution" element={<Solution />} />
        <Route path="/About" element={<About />} />
        <Route path="/Contact" element={<Contact />} />  
        <Route path="/Demo" element={<Demo />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
